import { FaRegCommentDots, FaPlus, FaTrashAlt, FaPhone, FaCalendarAlt, FaTasks } from "react-icons/fa";
import { HiOutlinePencil } from "react-icons/hi";
import { MdOutlineEmail } from "react-icons/md";
import { get } from "../../../../utils/helpers/api";
import { useEffect, useState } from "react";
import TimelineItemContent from "./Item";
import { useTranslation } from "react-i18next";
import { useSettings } from "../../../../context/settings";

const EVENT_ICONS = {
  created:     <FaPlus />,
  updated:     <HiOutlinePencil />,
  deleted:     <FaTrashAlt />,
  note:        <FaRegCommentDots />,
  call:        <FaPhone />,
  email:       <MdOutlineEmail />,
  meeting:     <FaCalendarAlt />,
  task:        <FaTasks />,
};

function Timeline({ subjectType, subjectId }) {
  const { t } = useTranslation();
  const { formatDate } = useSettings();

  function groupByDate(items) {
    const groups = {};
    items.forEach((item) => {
      const key = formatDate(item.created_at);
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    });
    return groups;
  }
  const [timelineData, setTimelineData] = useState([]);

  useEffect(() => {
    if (subjectType && subjectId) {
      getTimeline();
    }
  }, [subjectType, subjectId]);

  const getTimeline = async () => {
    const data = await get(`/crm/timeline/${subjectType}/${subjectId}`);
    if (data?.success) {
      setTimelineData(data.items);
    }
  };

  const groups = groupByDate(timelineData);

  return (
    <div className="crm-vertical-timeline mt-3 ms-lg-3">
      {Object.keys(groups).length === 0 ? (
        <p className="text-muted ms-5">{t('crm.noActivityYet')}</p>
      ) : (
        Object.entries(groups).map(([date, items]) => (
          <div className="crm-vertical-timeline-date-group" key={date}>
            <div className="crm-vertical-timeline-date-header">
              <div className="crm-vertical-timeline-date-badge">{date}</div>
            </div>

            {items.map((item) => (
              <div className="crm-vertical-timeline-item" key={item.id}>
                <div className="crm-vertical-timeline-icon">
                  {EVENT_ICONS[item.event_type] ?? <FaRegCommentDots />}
                </div>
                <TimelineItemContent item={item} />
              </div>
            ))}
          </div>
        ))
      )}
    </div>
  );
}

export default Timeline;
